import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Chip, the applied-filter chip in a toolbar.
 *
 * Source selectors: `system.css` `.dsk-chip` and `.dsk-chip.is-active`.
 *
 * Doctrine enforced:
 * - A chip is a COMMAND, it changes the result set, so the applied state is an
 *   INK invert, not an accent tint. `.dsk-chip.is-active .ph` is already forced
 *   to `color: inherit` upstream so a filled glyph stays on-ink.
 * - `active` mirrors `aria-pressed`, so the visual state and the announced
 *   state can never disagree.
 * - A chip never wraps. Long chip text is the `.dsk-fit` behaviour's problem,
 *   not a two-line chip's.
 */
export const Chip = React.forwardRef(function Chip(
  { active = false, type, className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type || 'button'}
      aria-pressed={active}
      className={cn('dsk-chip', active && 'is-active', className)}
      {...rest}
    />
  );
});
Chip.displayName = 'Chip';

export default Chip;
